import classNames from 'classnames';
import React from 'react';
import { Card } from 'react-bootstrap';
import { Color, Variant } from 'react-bootstrap/types';

export interface SlimPageCardProps extends React.HTMLAttributes<HTMLElement> {
  bg?: Variant;
  text?: Color;
  border?: Variant;
  body?: boolean;
  noCard?: boolean;
}

export const SlimPageCard = (
  props: React.PropsWithChildren<SlimPageCardProps>,
) => {
  const { noCard, children, ...cardProps } = props;

  if (noCard) {
    return (
      <div className={classNames('page-card', props.className)}>{children}</div>
    );
  }

  return (
    <Card
      body={false}
      {...cardProps}
      className={classNames('page-card', props.className)}
    >
      {children}
    </Card>
  );
};

SlimPageCard.defaultProps = {
  // border: "0",
  body: true,
  bg: 'white',
  text: 'dark',
};

export default SlimPageCard;
